// extracted by mini-css-extract-plugin
module.exports = {"container":"e_xf","title":"e_yf","wavy":"e_zf","navLink":"e_Af","active":"e_Bf","iconArrow":"e_Cf"};